import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDealer } from "@/contexts";
import ScanDealerCodeDialog from "@/components/organisms/ScanDealerCodeDialog";
import * as S from "./styles";

const Login: React.FC = () => {
  const navigate = useNavigate();
  const { dealer } = useDealer();

  useEffect(() => {
    console.log('Login component - Current dealer state:', dealer);
    if (dealer) {
      console.log('Login component - Navigating to /login/channels');
      navigate("/login/channels");
    }
  }, [dealer]);

  return (
    <S.LoginPage>
      <ScanDealerCodeDialog
        open={true}
        onClose={() => {
          console.log('Login component - Dialog closed');
        }}
      />
    </S.LoginPage>
  );
};

export default Login; 